import React, { Component } from 'react'
import './Obhodnoilist.css'
import ReactToPrint, { PrintContextConsumer } from 'react-to-print';
import './SpravkaObOkonch.css'

export default class SpravkaObOkonch extends Component {
    constructor(props) {
        super(props)
        var today = new Date(),
            date = today.getDate() + '.' + (today.getMonth().length < 8 ? '0' : '') + (today.getMonth() + 1) + '.' + today.getFullYear();
        // datetime = (today.getDate() + '.' + (today.getMonth() + 1) + '.' + today.getFullYear() + ' ' + today.getHours() + ':' + today.getMinutes() + ':' + today.getSeconds())
        this.state = {
            // currentDateTime: datetime,
            number_of_report: null,
            currentDate: date,
            openreport: null
        }
    }

    OpenReportsPage(reportsPage, reportType) {
        this.props.OpenReportsPage(reportsPage, reportType)
    }
    selectLanguage(language) {
        this.props.selectLanguage(language)
    }
    onChange = (e) => {
        this.setState({ number_of_report: e.target.value })
    }
    openReport() {
        this.setState({
            openreport: this.state.number_of_report
        })
    }

    render() {
        const { Leave } = this.props
        // console.log("Leave", Leave)
        if (Leave && Leave === null) return null
        return (
            <div className='ObhodnoiList D_main_header' >
                <header>
                    <i className="fas fa-arrow-left" onClick={() => this.OpenReportsPage(0, 0)}></i>
                    <ReactToPrint content={() => this.componentRef}>
                        <PrintContextConsumer>
                            {({ handlePrint }) => (
                                <i onClick={handlePrint} className="fa fa-print" title="Печать"></i>
                            )}
                        </PrintContextConsumer>
                    </ReactToPrint>
                    <div className='SpravkaObOkonch_input'>
                        <p>Введите номер справки</p>
                        <input type='number' onChange={this.onChange}>
                        </input>
                        {this.state.number_of_report !== null && this.state.number_of_report !== ' ' &&
                            <button onClick={() => this.openReport()}>
                                <h5>Просмотр отчета</h5>
                            </button>
                        }
                    </div>
                    {this.props.language === 1 ? <h2>Справка об окончании</h2> : <h2>Справка об окончании</h2>}
                    {/* <div className='Language'>
                        <h4 onClick={() => this.selectLanguage(1)} className={this.props.language === 1 ? 'Lang_Active' : 'Lang'}>Рус</h4>
                        <h4 onClick={() => this.selectLanguage(2)} className={this.props.language === 2 ? 'Lang_Active' : 'Lang'}>Кырг</h4>
                    </div> */}
                </header>

                <div className="A4 SpravkaObOkonch" ref={el => (this.componentRef = el)}>
                    {Leave.length > 0 ?
                        <>
                            {this.state.openreport !== null && this.state.openreport !== ' ' ?
                                <>
                                    <table>
                                        <thead>
                                            <tr >
                                                <th colSpan='2' >
                                                    {Leave && Leave.length && Leave[1].length && Leave[1][0].mo}
                                                </th>
                                            </tr>
                                            <tr >
                                                <th colSpan='2' >
                                                    {Leave && Leave.length && Leave[1].length && Leave[1][0].v2}
                                                </th>
                                            </tr>
                                            <tr>
                                                <td style={{ textAlign: 'left', fontSize: '11px', paddingRight: '20%' }}>
                                                    {`720001, Кыргызстан, Бишкек ш. Чуй к.,215
                                    Тел.:+996 312 612908, факс: +996 312 613148`}
                                                </td>
                                                <td style={{ width: '40%', textAlign: 'left', fontSize: '11px' }}>
                                                    {`720001, Кыргызстан, г.Бишкек пр.Чуй, 215
                                    E-mail: igdigt@mail.ru`}
                                                </td>
                                            </tr>
                                            <tr>
                                                <th colSpan='2' style={{ paddingTop: '16px' }}>
                                                    СПРАВКА ОБ ОКОНЧАНИИ
                                                </th>
                                            </tr>
                                            <tr>
                                                <th colSpan='2'>
                                                    № {this.state.number_of_report}
                                                </th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr >
                                                <th colSpan='2'>{Leave && Leave.length && Leave[0].length && Leave[0][0].s_fio}</th>
                                            </tr>
                                            <tr >
                                                <td colSpan='2'>
                                                    {`действительно окончил(а) в   году ${Leave && Leave.length && Leave[1].length && Leave[1][0].v2} 
                                             по направлению  ${Leave && Leave.length && Leave[0].length && Leave[0][0].p25_2} 
                                             с присвоением им квалификации «${Leave && Leave.length && Leave[0].length && Leave[0][0].NameQualification}»`}
                                                </td>
                                            </tr>
                                            <tr>
                                                <td colSpan='2'>
                                                    {` Приказ № ${Leave && Leave.length && Leave[0].length && Leave[0][0].leave_reg} 
                                   от ${Leave && Leave.length && Leave[0].length && Leave[0][0].leave_date}`}
                                                </td>
                                            </tr>
                                            <tr>
                                                <td colSpan='2'>
                                                    {`Справка выдана временно, из-за отсутствия бланков дипломов`}
                                                </td>
                                            </tr>
                                            <tr>
                                                <td colSpan='2'>
                                                    Справка выдана по месту требования
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                    <table>
                                        <tbody>
                                            <tr>
                                                <td style={{ width: '50%', textAlign: 'left' }}>
                                                    {this.state.currentDate} год
                                                </td>
                                                <th style={{ fontSize: '14px' }}>
                                                    {Leave && Leave.length && Leave[2].length && Leave[2][0].insert_pole}
                                                </th>
                                            </tr>
                                            <tr>
                                                <td>
                                                </td>
                                                <th style={{ paddingTop: '5px', fontSize: '14px' }}>
                                                    {Leave && Leave.length && Leave[3].length && Leave[3][0].insert_pole}
                                                </th>
                                            </tr>
                                        </tbody>
                                    </table>
                                </> : null} </> : <h1>Нет данных</h1>
                    }
                </div>
            </div>
        )
    }
}


